<template>
  <ul class="ulReset">
    <li v-for="(stockInfo, index) in stockInfosDisplay" :key="stockInfo.store.id" :class="[$style.stockInfoItem, {[$style.stockInfoItemLast]: index === stockInfos.length -1}]">
      <div :class="$style.stockInfoHeader">
        <h3 :class="$style.stockInfoHeaderName">
          {{ stockInfo.store.name }}
        </h3>
        <div :class="$style.stockInfoHeaderAddress">
          <lv-button
            styling="link-primary-version2"
            :class="$style.stockInfoHeaderAddressLink"
            :href="stockInfo.mapsUrl"
            target="_blank"
          >
            {{ stockInfo.addressText }}
          </lv-button>
        </div>
        <div :class="$style.stockInfoHeaderPhoneNumber">
          {{ $awt('aw.common.product.informations.accordion.product_stock_info.tel', { phone_number: stockInfo.store.phoneNumber }) }}
        </div>
      </div>
      <div :class="[$style.stockInfoDetail, $style[`stockInfoDetail${stockInfo.stockLevel}`] ]">
        <div :class="$style.stockInfoDetailIconContainer">
          <lv-icon
            v-if="stockInfo.stockLevel === 'outOfStock' || stockInfo.stockLevel === 'low'"
            name="error-version2-16"
            :size="16"
            style="vertical-align: unset"
          />
          <lv-icon
            v-else
            name="check-circle-version2-16"
            :size="16"
            style="vertical-align: unset"
          />
        </div>
        <div>
          <span v-if="stockInfo.stockLevel === 'outOfStock' || stockInfo.stockLevel === 'low'">
            {{ $awt('aw.common.product.informations.accordion.product_stock_info.probably_not_available') }}
          </span>
          <span v-else>
            {{ $awt('aw.common.product.informations.accordion.product_stock_info.probably_available') }}
          </span>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
  import { LvButton, LvIcon } from '~~/common/components/loginet-vue-shop/index.mjs';
  import { computed } from 'vue';
  import { createStockInfosList } from '~~/common/utils/stockInfoDisplay.js';

  const props = defineProps({
    stockInfos: {
      type: Array,
      required: true,
    },
  });

  const stockInfosDisplay = computed(() => {
    return createStockInfosList(props.stockInfos);
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.stockInfo {
  &Header {
    display: grid;
    margin-bottom: 8px;
    padding-left: 8px;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    grid-template-areas: "name phoneNumber" "address phoneNumber";

    &Name {
      font-size: 14px;
      font-weight: $font-weight-bold-v2;
      line-height: 20px;
      grid-area: name;

      @include tablet(min) {
        font-size: 16px;
        line-height: 24px;
      }
    }

    &Address {
      grid-area: address;

      &Link {
        font-size: 12px;
        font-weight: $font-weight-medium-v2;
        line-height: 16px;
        width: auto;
        padding: 0;
        text-align: left;

        @include tablet(min) {
          font-size: 14px;
          line-height: 20px;
          text-decoration: underline;
        }
      }
    }

    &PhoneNumber {
      font-size: 12px;
      font-weight: $font-weight-regular-v2;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: $color-text-secondary;
      grid-area: phoneNumber;

      @include tablet(min) {
        font-size: 14px;
        font-weight: $font-weight-normal-v2;
        line-height: 20px;
      }
    }
  }

  &Item {
    margin-top: 16px;
    padding-bottom: 12px;
    border-bottom: 1px dashed $color-dash-separator;

    &Last {
      border-bottom: none;
    }
  }

  &Detail {
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    padding: 16px;
    color: $color-sage-450;
    border-radius: 12px;
    background-color: $color-background-success;
    gap: 12px;

    @include tablet(min) {
      font-size: 14px;
      line-height: 20px;
    }

    &IconContainer {
      height: 16px;
    }

    &outOfStock, &low {
      color: $color-strawberry-450;
      background-color: $color-error-v1-background;
    }
  }
}
</style>
